import { render, staticRenderFns } from "./addChannel.vue?vue&type=template&id=7e97ed83"
import script from "./addChannel.vue?vue&type=script&lang=js"
export * from "./addChannel.vue?vue&type=script&lang=js"
import style0 from "./addChannel.vue?vue&type=style&index=0&id=7e97ed83&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e97ed83')) {
      api.createRecord('7e97ed83', component.options)
    } else {
      api.reload('7e97ed83', component.options)
    }
    module.hot.accept("./addChannel.vue?vue&type=template&id=7e97ed83", function () {
      api.rerender('7e97ed83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/channelVolume/cmp/addChannel.vue"
export default component.exports